import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

const footerNav = [
  { label: "关于我们", to: "/about" },
  { label: "联系反馈", to: "/contact" },
  { label: "全部内容", to: "/search?q=城市" },
  { label: "专题合集", to: "/#topics" },
];

export default function SiteFooter() {
  return (
    <footer className="mt-16 bg-primary-950 text-background-100">
      <div className="px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <Link to="/" className="inline-flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 font-editorial text-lg font-bold text-background-50">
                抖
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-editorial text-xl font-bold tracking-wide text-background-50">抖阳</span>
                <span className="mt-1 font-label text-[10px] tracking-[0.28em] text-background-400">DUYANG</span>
              </span>
            </Link>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-300">
              抖阳专注原创内容与多元资讯，覆盖文化、娱乐、生活与观点领域。我们相信深度内容的价值，也相信读者值得被认真对待。
            </p>
            <div className="mt-6 flex flex-wrap items-center gap-3">
              <span className="rounded-full border border-background-700 px-3 py-1 text-xs text-background-300">原创内容</span>
              <span className="rounded-full border border-background-700 px-3 py-1 text-xs text-background-300">深度资讯</span>
              <span className="rounded-full border border-background-700 px-3 py-1 text-xs text-background-300">每周更新</span>
            </div>
          </div>

          <div>
            <h2 className="font-label text-xs uppercase tracking-[0.2em] text-background-400">内容分类</h2>
            <ul className="mt-4 space-y-2.5">
              {categories.map((item) => (
                <li key={item.id}>
                  <Link
                    to={`/category/${item.id}`}
                    className="text-sm text-background-200 transition-colors hover:text-background-50"
                  >
                    {item.name} · {item.en}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h2 className="font-label text-xs uppercase tracking-[0.2em] text-background-400">关于抖阳</h2>
            <ul className="mt-4 space-y-2.5">
              {footerNav.map((item) => (
                <li key={item.label}>
                  <Link
                    to={item.to}
                    className="text-sm text-background-200 transition-colors hover:text-background-50"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
            <div className="mt-6 flex items-center gap-2">
              {["ri-weibo-fill", "ri-wechat-fill", "ri-mail-line"].map((icon) => (
                <span
                  key={icon}
                  className="flex h-8 w-8 items-center justify-center rounded-md border border-background-700 text-background-300"
                >
                  <i className={`${icon} text-sm`} />
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-background-800 pt-6 text-xs text-background-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 抖阳 DUYANG. 本站为内容演示站点，全部内容为示例数据。</p>
          <p className="flex flex-wrap items-center gap-4">
            <span>内容政策</span>
            <span>版权说明</span>
            <span>合作投稿：editor@duyang.example</span>
          </p>
        </div>
      </div>
    </footer>
  );
}